import { DISCORD_LINK } from "../../Utils";
import { MODEL_OUTAGE_MESSAGE_PARTS } from "../../lib/modelOutage";

const DEFAULT_LINK_CLASS = "hover:brightness-[1.50] transition-all duration-200 ease-in-out underline pl-0";

const ModelOutageMessage = ({ supportUrl, className = "", linkClassName = DEFAULT_LINK_CLASS, linkTarget = "_blank", linkRel = "noopener noreferrer" }) => {
  if (!supportUrl) {
    return null;
  }

  return (
    <span className={className}>
      {MODEL_OUTAGE_MESSAGE_PARTS.prefix}
      <a
        href={DISCORD_LINK}
        target={linkTarget}
        rel={linkRel}
        className={linkClassName}
      >
        {MODEL_OUTAGE_MESSAGE_PARTS.updatesLinkText}
      </a>
      {MODEL_OUTAGE_MESSAGE_PARTS.connector}
      <a
        href={supportUrl}
        target={linkTarget}
        rel={linkRel}
        className={linkClassName}
      >
        {MODEL_OUTAGE_MESSAGE_PARTS.supportLinkText}
      </a>
      {MODEL_OUTAGE_MESSAGE_PARTS.suffix}
    </span>
  );
};

export default ModelOutageMessage;
